import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import './Profile.css';

export default function Profile({ employee, onLogout }) {
  const [profile, setProfile]   = useState(null);
  const [salary, setSalary]     = useState(null);
  const [attendance, setAttendance] = useState(null);
  const [loading, setLoading]   = useState(true);

  const now   = new Date();
  const month = now.getMonth() + 1;
  const year  = now.getFullYear();

  useEffect(() => { loadAll(); }, []);

  const loadAll = async () => {
    try {
      setLoading(true);
      const [profData, salData, attData] = await Promise.all([
        api.getMyProfile(),
        api.getMySalary(month, year),
        api.getMyAttendance(month, year),
      ]);
      setProfile(profData);
      setSalary(salData);
      setAttendance(attData);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const initials = employee?.full_name
    ? employee.full_name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()
    : '??';

  const summary = attendance?.summary || {};
  const records = attendance?.records || [];
  const presentDays = records.filter(r => r.clock_in).length;
  const totalDays   = records.length;
  const attendanceRate = totalDays > 0 ? ((presentDays / totalDays) * 100).toFixed(1) : '0.0';

  return (
    <div className="profile-page">

      {/* Hero */}
      <div className="profile-hero">
        <div className="profile-avatar">{initials}</div>
        <div className="profile-name">{employee?.full_name || '—'}</div>
        <div className="profile-dept">
          {profile?.department_name || profile?.department || employee?.department || 'Fotile Pakistan'}
        </div>
        <span className="profile-badge">Active Employee</span>
      </div>

      {/* Employee details */}
      <div className="prof-section-label">Employee Details</div>
      <div className="prof-card">
        {[
          { key: 'Employee ID', val: employee?.employee_id || '—', mono: true },
          { key: 'Department',  val: profile?.department_name || profile?.department || '—' },
          { key: 'Job Title',   val: profile?.job_title || employee?.job_title || '—' },
          { key: 'Location',    val: profile?.location_name || '—' },
          { key: 'Shift',       val: profile?.shift_name || '—' },
          { key: 'Role',        val: employee?.role ? employee.role.charAt(0).toUpperCase() + employee.role.slice(1) : '—' },
          { key: 'Joined',      val: profile?.joining_date ? new Date(profile.joining_date).toLocaleDateString('en-PK', { day: 'numeric', month: 'short', year: 'numeric' }) : '—' },
        ].map((r, i) => (
          <div key={i} className="prof-row">
            <span className="prof-key">{r.key}</span>
            <span className={`prof-val ${r.mono ? 'mono' : ''}`}>{r.val}</span>
          </div>
        ))}
      </div>

      {/* This month summary */}
      <div className="prof-section-label" style={{ marginTop: 16 }}>
        {now.toLocaleString('default', { month: 'long' })} {year} — Summary
      </div>
      <div className="prof-card">
        {loading ? (
          <div className="prof-loading">Loading…</div>
        ) : (
          [
            { key: 'Days Present',    val: summary.present || 0,            color: 'green' },
            { key: 'Days Absent',     val: summary.absent  || 0,            color: summary.absent > 0 ? 'red' : '' },
            { key: 'Late Instances',  val: summary.lates   || 0,            color: summary.lates > 0 ? 'amber' : '' },
            { key: 'Total Late Time', val: summary.total_late_minutes > 0 ? `${summary.total_late_minutes}m` : '—', color: '' },
            { key: 'Attendance Rate', val: `${attendanceRate}%`,            color: parseFloat(attendanceRate) >= 80 ? 'green' : 'red', big: true },
            { key: 'Deduction',       val: salary?.deduction_percent ? `${salary.deduction_percent}%` : '0%', color: parseFloat(salary?.deduction_percent) > 0 ? 'red' : 'green' },
          ].map((r, i) => (
            <div key={i} className="prof-row">
              <span className="prof-key">{r.key}</span>
              <span className={`prof-val ${r.color} ${r.big ? 'big' : ''}`}>{r.val}</span>
            </div>
          ))
        )}
      </div>

      <button className="logout-btn" onClick={onLogout}>Sign Out</button>

    </div>
  );
}